import React, { useEffect } from 'react';
import Loader from '../../../common/loader';
import { useMobileVerifyContext } from '../../context/MobileVerifyContext';
import { MobileVerifyResponseType } from '../../hooks/useMobileVerify';
import { useVerifyLayout } from '../../hooks/useVerifyLayout/useVerifyLayout';
import { styles } from './Landing.css';

const Landing = ({ handleRedirect }: { handleRedirect: (data: MobileVerifyResponseType) => void }) => {
  const { data: mobileData } = useMobileVerifyContext();
  const { loadingMessage } = useVerifyLayout();

  useEffect(() => {
    if (!mobileData.loading && !mobileData.isFinished) {
      handleRedirect(mobileData);
    }
  }, []);

  return (
    <div className={styles.container}>
      <Loader />
      <strong className={styles.loadingText}>{loadingMessage}</strong>
    </div>
  );
};

export default Landing;
